/* eslint-disable max-len */
var ICON_UI_ADD = {
  v2: true,
  "default": 'M0.75 12H23.25M12 0.75V23.25',
  globetrotter: 'M1.875 12H22.125M12 1.875V22.125'
};

export { ICON_UI_ADD };
//# sourceMappingURL=ICON_UI_ADD.js.map
